import React, { useContext } from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { FormContext } from '../index'

const ColorCircularProgress = withStyles({
  root: {
    color: 'white',
  },
})(CircularProgress)

const StyledButton = withStyles(styles)(Button)

const SubmitButton = props => {
  const form = useContext(FormContext)

  const onClick = e => {
    form && form.submit && form.submit(e, form)
    props.onClick && props.onClick(e, form)
  }

  const circleSize = props.circleSize ? props.circleSize : 25

  return (
    <StyledButton
      variant="contained"
      size={props.size || 'large'}
      {...props}
      onClick={onClick}
      disabled={props.disabled}
    >
      {props.formSubmitting ? (
        <ColorCircularProgress size={circleSize} />
      ) : (
        props.value
      )}
      {props.children}
    </StyledButton>
  )
}
export default SubmitButton
